import React from 'react';

type SVGIconProps = {
  IconComponent: React.ComponentType; // Accepts a React component as a prop
  className?: string;
  scale? : string;
};

const SVGIcon: React.FC<SVGIconProps> = ({ IconComponent, className , scale='scale-150' }) => {
  return (
    <div className={scale + ' ' + className}>
      <IconComponent />
    </div>
  );
};

export default SVGIcon;
